var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dropbox_svg__clip0_5004_20743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0L0 4.875l8 4.82 8-4.82L8 0zm16 0l-8 4.875 8 4.82 8-4.82L24 0zM0 14.625L8 19.5l8-4.875L8 9.75l-8 4.875zM24 9.75l-8 4.875 8 4.875 8-4.875-8-4.875zM8 21.125L16 26l8-4.875-8-4.82-8 4.82z",
    fill: "#0062FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dropbox_svg__clip0_5004_20743"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v26H0z"
  })))));
}
export default SvgDropbox;